var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.06 15.94a1.5 1.5 0 00-2.12 2.12l9.498 9.5h-3.732a6.206 6.206 0 00-6.206 6.206v25.883a6.206 6.206 0 006.206 6.206h42.028l3.973 3.973a1.5 1.5 0 102.12-2.121L15.062 15.939zm42.674 46.915l-9.878-9.877a10.913 10.913 0 11-15.42-15.42l-6.998-6.999h-6.732a3.206 3.206 0 00-3.206 3.207v25.883a3.206 3.206 0 003.206 3.206h39.028zM34.56 39.682a7.912 7.912 0 1011.173 11.172L34.56 39.682zM32.825 20.5a1.5 1.5 0 000 3H46.14l4.26 6.392a1.5 1.5 0 001.249.667h9.412a3.206 3.206 0 013.206 3.207v21.977a1.5 1.5 0 003 0V33.766a6.206 6.206 0 00-6.206-6.207h-8.61l-4.26-6.39a1.5 1.5 0 00-1.248-.669H32.824z",
    fill: "var(--kf-color-gray-600)",
    fillOpacity: 0.5
  })));
}
export default SvgNoCamera;